<template>
  <!-- 最低血氧图表 -->
  <div class="healthy_measure_charts_card_item">
    <div class="item-header">
      <img :src="getIcon" alt="指标图标" class="item-icon" />
      <span v-if="type !== 'bloodPressure'" class="item-title">{{ getTitle }} <span :class="getValueClass">{{ getValue }}{{ getUnit }}</span></span>
      <span v-if="type === 'bloodPressure'" class="item-title">
				收缩压 
				<span :class="{ abnormal: model.systolicBloodPressureMinAbnormal === 1 }">{{ this.$lodash.get(this.$props.model, 'systolicBloodPressureMin', '-' ) !== null ? this.$lodash.get(this.$props.model, 'systolicBloodPressureMin', '-' ) : '-' }}</span>
				<span>-</span>
				<span :class="{ abnormal: model.systolicBloodPressureMaxAbnormal === 1 }">{{ this.$lodash.get(this.$props.model, 'systolicBloodPressureMax', '-' ) !== null ? this.$lodash.get(this.$props.model, 'systolicBloodPressureMax', '-' ) : '-' }}</span>
				mmHg，舒张压 
				<span :class="{ abnormal: model.diastolicBloodPressureMinAbnormal === 1 }">{{ this.$lodash.get(this.$props.model, 'diastolicBloodPressureMin', '-' ) !== null ? this.$lodash.get(this.$props.model, 'diastolicBloodPressureMin', '-' ) : '-' }}</span>
				<span>-</span>
				<span :class="{ abnormal: model.diastolicBloodPressureMaxAbnormal === 1 }">{{ this.$lodash.get(this.$props.model, 'diastolicBloodPressureMax', '-' ) !== null ? this.$lodash.get(this.$props.model, 'diastolicBloodPressureMax', '-' ) : '-' }}</span>
				mmHg
			</span>
    </div>
    <div class="reference">
			<span class="reference-value">{{ getDesc }}</span>
			<div style="display: flex; align-items: center;">
				<template v-if="type === 'bloodPressure'">
					<div class="reference-border_line" style="border: 1px dashed #1890FF;"></div>
					<span class="reference-text" style="margin-right: 12px;">收缩压</span>
					<div class="reference-block"></div>
					<span class="reference-text">正常范围</span>
					<div class="reference-split_line"></div>
					<div class="reference-border_line"></div>
					<span class="reference-text" style="margin-right: 12px;">舒张压</span>
				</template>
				<div class="reference-block" :style="{ background: type === 'bloodPressure' ? 'rgba(195, 148, 254, 0.15)' : 'rgba(24, 144, 255, 0.1)' }"></div>
				<span class="reference-text">正常范围</span>
			</div>
		</div>
    <div :id="`chart-container-${echartId}`" class="chart-container" :style="{ height: type === 'bloodPressure' ? '330px' : type === 'bodyTemperature' ? '180px' : '110px' }"></div>
  </div>
</template>

<script>
import * as echarts from 'echarts';

export default {
  name: 'MeasurementIndicators',
  props: {
    // 指标类型：血氧-oxygenSaturation 脉率-pulseRate 血压-bloodPressure 体温-bodyTemperature
    type: {
      type: String,
      default: 'oxygenSaturation',
      validator: (val) => {
        return ['oxygenSaturation', 'pulseRate', 'bloodPressure', 'bodyTemperature'].includes(val);
      }
    },
    echartId: {
      type: String,
      required: true,
      default: () => `chart-${Date.now()}`
    },
		option: {
			type: Object,
			required: true,
			default: {}
		},
		model: {
			type: Object,
			required: true,
			default: {}
		}
  },
  data() {
    return {
      myChart: null,
      chartData: {
        dates: ['12-27', '12-28', '12-29', '12-30', '01-01', '01-02', '01-03'],
        series: [
          { name: '血氧趋势', data: [98, 99, 99, 99, 97, 98, 99], lineStyle: { color: '#1890FF' } },
          { name: '异常点', data: [null, null, null, null, 93, null, null], lineStyle: { color: '#FF6B6B' }, symbolSize: 8 }
        ]
      }
    };
  },
  computed: {
    getIcon() {
      const iconMap = {
        oxygenSaturation: require('@/assets/icon_dean_home_card_measure_7.png'),
        pulseRate: require('@/assets/icon_dean_home_card_measure_8.png'),
        bloodPressure: require('@/assets/icon_dean_home_card_measure_9.png'),
        bodyTemperature: require('@/assets/icon_dean_home_card_measure_10.png')
      };
      return iconMap[this.type];
    },
    getDesc() {
      const descMap = {
        oxygenSaturation: '参考值：95%～100%',
        pulseRate: '参考值：40～100',
        bloodPressure: '参考值：90≤收缩压<140，60≤舒张压<90',
        bodyTemperature: '参考值：<37.5°C'
      };
      return descMap[this.type];
    },
		getTitle() {
			const descMap = {
        oxygenSaturation: '最低血氧',
        pulseRate: '平均脉率',
        bloodPressure: '-',
        bodyTemperature: '最高体温'
      };
      return descMap[this.type];
		},
		getValue() {
			const descMap = {
        oxygenSaturation: this.$lodash.get(this.$props.model, 'oxygenSaturation', '-' ) !== null ? this.$lodash.get(this.$props.model, 'oxygenSaturation', '-' ) : '-',
        pulseRate: this.$lodash.get(this.$props.model, 'pulseRate', '-' ) !== null ? this.$lodash.get(this.$props.model, 'pulseRate', '-' ) : '-',
        bodyTemperature: this.$lodash.get(this.$props.model, 'bodyTemperature', '-' ) !== null ? this.$lodash.get(this.$props.model, 'bodyTemperature', '-' ) : '-'
      };
      return descMap[this.type];
		},
		getValueClass() {
			const descMap = {
        oxygenSaturation: this.$props.model.oxygenSaturationAbnormal == 1 ? 'abnormal' : '',
        pulseRate: this.$props.model.pulseRateAbnormal == 1 ? 'abnormal' : '',
        bodyTemperature: this.$props.model.bodyTemperatureAbnormal == 1 ? 'abnormal' : '',
      };
      return descMap[this.type];
		},
		getUnit() {
			return this.type === 'oxygenSaturation' ? '%' : this.type === 'bodyTemperature' ? '°C' : '';
		},
  },
  mounted() {
    this.$nextTick(() => {
      this.initOxygenChart();
    });
    window.addEventListener('resize', this.handleChartResize);
  },
  beforeDestroy() {
    if (this.myChart) {
      this.myChart.dispose();
      this.myChart = null;
    }
    window.removeEventListener('resize', this.handleChartResize);
  },
  methods: {
    initOxygenChart() {
      const chartDom = document.getElementById(`chart-container-${this.echartId}`);
      
      if (!chartDom || this.myChart) return;

      this.myChart = echarts.init(chartDom);

      const option = this.$props.option;

      if (!option || typeof option !== 'object') {
        console.error('ECharts配置项错误，请检查 getEchartOptionMeasure1 函数');
        return;
      }

      this.myChart.setOption(option);
    },
    // 单独的resize处理函数
    handleChartResize() {
      if (this.myChart) {
        this.myChart.resize();
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.healthy_measure_charts_card_item {
  margin-bottom: 16px;
  background: #FFFFFF;
  border-radius: 2px;
  padding: 20px 16px;
  box-sizing: border-box;

  .item-header {
    display: flex;
    align-items: center;
    margin-bottom: 8px;
    gap: 8px; // 替代margin-right，兼容性更好

    .item-icon {
      width: 20px;
      height: 20px;
      object-fit: contain; // 防止图标变形
    }

    .item-title {
      font-family: PingFangSC, PingFang SC;
      font-weight: 400;
      font-size: 20px;
      color: #1F2635;
      line-height: 28px;
      margin-right: 16px; // 标题之间加间距

      .abnormal {
        color: rgba(255, 113, 134, 1);
        font-weight: 500;
      }
    }
  }

  .reference {
    margin-left: 24px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-wrap: wrap; // 防止小屏幕换行错乱
    gap: 8px;

    .reference-value {
      font-family: PingFangSC, PingFang SC;
      font-weight: 400;
      font-size: 16px;
      color: #9094A6;
      line-height: 22px;
    }

    .reference-flex_1 {
      flex: 1;
      min-width: 100px; // 防止flex挤压消失
    }

    .reference-split_line {
      width: 1px;
      height: 13px;
      background: rgba(144, 148, 166, 0.2);
      margin: 0 15px;
    }

    .reference-border_line {
      width: 27px;
      height: 1px;
      border: 1px solid #1890FF;
      margin-right: 4px;
    }

    .reference-block {
      width: 20px;
      height: 12px;
      background: rgba(24, 144, 255, 0.1);
      margin-right: 4px;
    }

    .reference-text {
      font-family: PingFangSC, PingFang SC;
      font-weight: 400;
      font-size: 12px;
      color: #9094A6;
      line-height: 17px;
    }
  }

  // 8. 确保图表容器有明确尺寸（原代码高度足够，但加min-width更稳妥）
  .chart-container {
    width: 100%;
    min-width: 300px; // 防止小屏幕宽度为0
    height: 110px;
    margin-top: 8px;
  }
}
</style>